export default __webpack_public_path__ + "static/contour-map-174cbb60a940d9dd3c43ecc8f80da375.svg";